/* eslint-disable @typescript-eslint/no-namespace */ //! this file contains namespaced schemas for the dbJson fields
import { z } from 'zod';
import { widgetConfigSchema as wConfigSchema } from './corso-shopify-extensions/schema.js';
import { viewFilters } from './crew/schema/filters.js';
import { variant } from './crew/schema/storeProduct.js';
import { CountryCode } from './enums/countries.js';
import { helperSchema } from './zodExtensions.js';
export var DbJsonSchema;
(function (DbJsonSchema) {
    //! namespace relates a specific table in the DB
    let StoreUiConfig;
    (function (StoreUiConfig) {
        StoreUiConfig.WarrantyProgramName = {
            warranty: 'Warranty',
            guarantee: 'Guarantee',
        };
        StoreUiConfig.customerUiConfigSchema = z.object({
            merchantPrimaryColor: z.string(),
            merchantLogoUrl: z.string(),
            merchantBackgroundUrl: z.string().nullable(),
            merchantFaviconUrl: z.string(),
            footerText: z.string(),
            isReturnPhoneRequired: z.boolean().optional(),
            isWarrantyPhoneRequired: z.boolean().optional(),
            isRegistrationPhoneRequired: z.boolean().optional(),
            //! ---- any additional properties should be added as optional
            orderHubStartRequestTitleText: helperSchema.optionalizedString,
            orderHubStartRequestDetailText: helperSchema.optionalizedString,
            warrantyProgramName: z
                .nativeEnum(StoreUiConfig.WarrantyProgramName)
                .default('Warranty')
                .optional(),
            orderNumberDescriptionText: helperSchema.optionalizedString,
            orderLookupDetailText: helperSchema.optionalizedString,
            merchantBackgroundColor: helperSchema.optionalizedString,
            merchantPageTitle: helperSchema.optionalizedString,
            // refund + gift card text
            offerGiftCardDetailText: helperSchema.optionalizedString,
            offerRefundDetailText: helperSchema.optionalizedString,
            // green returns // allow customer to keep item
            noReturnRequiredItemsDetailText: helperSchema.optionalizedString,
            noReturnRequiredItemsHeadline: helperSchema.optionalizedString,
            warrantyItemsDetailText: helperSchema.optionalizedString,
            hideLabelDownloadWhenQrCodeIsPresent: z.boolean().optional(),
            // registrations
            orderLookupRegistrationText: helperSchema.optionalizedString,
            identifyProductUrl: helperSchema.optionalizedString,
            identifyProductUrlButtonText: helperSchema.optionalizedString,
            identifyProductDetailText: helperSchema.optionalizedString,
            identifyProductFormPlaceholder: helperSchema.optionalizedString,
            registrationSubmissionText: helperSchema.optionalizedString,
            registrationCountryCodes: z
                .array(z.nativeEnum(CountryCode))
                .default([])
                .optional(),
            // resolution component settings (picking between moneyBack, exchange, or storeCredit)
            shouldPrioritizeCredit: z.boolean().optional(),
            creditHeadlineText: helperSchema.optionalizedString,
            creditDetailText: helperSchema.optionalizedString,
        });
        // * potentially more at home in lib, than types
        StoreUiConfig.defaultStoreUiTheme = {
            merchantPrimaryColor: '#000000',
            merchantLogoUrl: 'https://cdn.corso.com/img/crew-ui-corso-logo.svg',
            merchantBackgroundUrl: null,
            merchantFaviconUrl: 'https://cdn.corso.com/img/crew-ui-corso-logo.svg',
            footerText: '',
        };
    })(StoreUiConfig = DbJsonSchema.StoreUiConfig || (DbJsonSchema.StoreUiConfig = {}));
    let StoreSettings;
    (function (StoreSettings) {
        StoreSettings.dashboards = z.object({
            dashboards: z.array(z.object({ id: z.string(), name: z.string() })),
        });
        StoreSettings.giftCardAttributes = z.object({
            message: helperSchema.nullifiedString,
            templateSuffix: helperSchema.nullifiedString,
        });
    })(StoreSettings = DbJsonSchema.StoreSettings || (DbJsonSchema.StoreSettings = {}));
    let StoreOrderLineItem;
    (function (StoreOrderLineItem) {
        StoreOrderLineItem.selectedOptionsSchema = z.array(z.object({ name: z.string(), value: z.string() }));
    })(StoreOrderLineItem = DbJsonSchema.StoreOrderLineItem || (DbJsonSchema.StoreOrderLineItem = {}));
    let StoreUiView;
    (function (StoreUiView) {
        StoreUiView.filtersSchema = viewFilters;
    })(StoreUiView = DbJsonSchema.StoreUiView || (DbJsonSchema.StoreUiView = {}));
    let ClaimLineItem;
    (function (ClaimLineItem) {
        ClaimLineItem.variantExchangeLineItemSchema = variant.partial().extend({
            idFromPlatform: variant.shape.idFromPlatform,
            price: variant.shape.price,
            quantity: variant.shape.quantity,
        });
        ClaimLineItem.replacementOrderLineItems = z.object({
            replacementItems: z.array(ClaimLineItem.variantExchangeLineItemSchema),
        });
    })(ClaimLineItem = DbJsonSchema.ClaimLineItem || (DbJsonSchema.ClaimLineItem = {}));
    let StoreProduct;
    (function (StoreProduct) {
        StoreProduct.options = z.array(z.object({ name: z.string(), position: z.number() }));
    })(StoreProduct = DbJsonSchema.StoreProduct || (DbJsonSchema.StoreProduct = {}));
    let ShipProtectClaim;
    (function (ShipProtectClaim) {
        ShipProtectClaim.replacementItemSchema = z.object({
            name: z.string().nullish(),
            sku: z.string().nullish(),
            idFromPlatform: z.string(),
            price: z.number().nullish(),
            quantity: z.number(),
            imgUrl: z.string().nullish(),
            tax: z.null(),
        });
        ShipProtectClaim.replacementItemDbSchema = z.object({
            items: z.array(ShipProtectClaim.replacementItemSchema),
        });
    })(ShipProtectClaim = DbJsonSchema.ShipProtectClaim || (DbJsonSchema.ShipProtectClaim = {}));
    let StoreProductVariant;
    (function (StoreProductVariant) {
        /** @deprecated we have migrated fully to selected options in the name value format */
        StoreProductVariant.selectedOptionsAsRecord = z.record(z.string());
        StoreProductVariant.selectedOptionsAsNameValue = z.array(z.object({ name: z.string(), value: z.string() }));
    })(StoreProductVariant = DbJsonSchema.StoreProductVariant || (DbJsonSchema.StoreProductVariant = {}));
    let StoreShipProtectSettings;
    (function (StoreShipProtectSettings) {
        StoreShipProtectSettings.widgetConfigSchema = wConfigSchema.nullable();
    })(StoreShipProtectSettings = DbJsonSchema.StoreShipProtectSettings || (DbJsonSchema.StoreShipProtectSettings = {}));
})(DbJsonSchema || (DbJsonSchema = {}));
//# sourceMappingURL=dbJsonSchemas.js.map